import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "otherCampaignPoolSizeInput",
        "saveButton",
        "customerMappingsContainer",
        "customerInternalIdInput",
        "autocompleteDropdown",
        "successMessage",
        "errorMessage",
        "errorMessageBody",
    ];
    static values = {
        allCustomerInternalIds: Array,
    };

    connect() {
        console.log("icm sync config editor controller connected");
        document.addEventListener("click", this.handleDocumentClick.bind(this));
    }

    disconnect() {
        document.removeEventListener("click", this.handleDocumentClick.bind(this));
    }

    handleDocumentClick(event) {
        if (!this.element.contains(event.target)) {
            this.hideAllAutocomplete();
        }
    }

    hideAllAutocomplete() {
        this.autocompleteDropdownTargets.forEach((dropdown) => {
            dropdown.classList.add("tw-hidden");
        });
    }

    showAutocomplete(event) {
        this.hideAllAutocomplete();
        const dropdown = event.currentTarget.nextElementSibling;
        dropdown.classList.remove("tw-hidden");
        this.filterAutocomplete(event);
    }

    filterAutocomplete(event) {
        const query = event.currentTarget.value.toLowerCase();
        const dropdown = event.currentTarget.nextElementSibling;
        const filteredIds = this.allCustomerInternalIdsValue.filter((id) => id.toLowerCase().includes(query));

        dropdown.innerHTML = "";
        filteredIds.forEach((id) => {
            const option = document.createElement("div");
            option.classList.add("jlls-multiselect-option");
            option.textContent = id;
            option.dataset.action = "click->icm-sync-config-editor#selectAutocomplete";
            dropdown.appendChild(option);
        });
    }

    selectAutocomplete(event) {
        const input = event.currentTarget.closest(".tw-relative").querySelector("input");
        input.value = event.currentTarget.textContent;
        this.hideAllAutocomplete();
    }

    hideMessages() {
        this.successMessageTarget.classList.add("tw-hidden");
        this.errorMessageTarget.classList.add("tw-hidden");
    }

    acceptProposedOtherCampaignPoolSize(event) {
        this.otherCampaignPoolSizeInputTarget.value = event.currentTarget.dataset.value;
    }

    addCustomerMapping() {
        const newMapping = this.createCustomerMappingElement("", "");
        this.customerMappingsContainerTarget.appendChild(newMapping);
    }

    removeCustomerMapping(event) {
        event.currentTarget.closest("[data-customer-id]").remove();
    }

    acceptProposedCustomerMapping(event) {
        const customerId = event.currentTarget.dataset.customerId;
        const jobCount = event.currentTarget.dataset.jobCount;

        let existingMapping = this.customerMappingsContainerTarget.querySelector(`[data-customer-id="${customerId}"]`);

        if (existingMapping) {
            existingMapping.querySelector('input[type="number"]').value = jobCount;
        } else {
            const newMapping = this.createCustomerMappingElement(customerId, jobCount);
            this.customerMappingsContainerTarget.appendChild(newMapping);
        }
    }

    createCustomerMappingElement(customerId, jobCount, readonly = false) {
        const div = document.createElement("div");
        div.classList.add("tw-flex", "tw-items-center", "tw-gap-2", "tw-mb-2");
        div.dataset.customerId = customerId;

        const customerIdInput = document.createElement("input");
        customerIdInput.type = "text";
        customerIdInput.classList.add("jlls-form-input");
        customerIdInput.value = customerId;
        customerIdInput.dataset.action =
            "focus->icm-sync-config-editor#showAutocomplete keyup->icm-sync-config-editor#filterAutocomplete";
        customerIdInput.dataset.icmSyncConfigEditorTarget = "customerInternalIdInput";
        if (readonly) {
            // customerIdInput.readOnly = true; // no longer needed
        } else {
            customerIdInput.placeholder = "Customer Internal ID";
        }

        const autocompleteDropdown = document.createElement("div");
        autocompleteDropdown.classList.add("jlls-multiselect-dropdown", "tw-hidden");
        autocompleteDropdown.dataset.icmSyncConfigEditorTarget = "autocompleteDropdown";

        const customerIdDiv = document.createElement("div");
        customerIdDiv.classList.add("tw-flex-1", "tw-relative");
        customerIdDiv.appendChild(customerIdInput);
        customerIdDiv.appendChild(autocompleteDropdown);

        const jobCountInput = document.createElement("input");
        jobCountInput.type = "number";
        jobCountInput.classList.add("jlls-form-input");
        jobCountInput.value = jobCount;
        jobCountInput.placeholder = "Anzahl Jobs";

        const removeButton = document.createElement("button");
        removeButton.type = "button";
        removeButton.classList.add("jlls-button-danger");
        removeButton.textContent = "Entfernen";
        removeButton.dataset.action = "click->icm-sync-config-editor#removeCustomerMapping";

        const jobCountDiv = document.createElement("div");
        jobCountDiv.classList.add("tw-flex-1");
        jobCountDiv.appendChild(jobCountInput);

        const removeButtonDiv = document.createElement("div");
        removeButtonDiv.classList.add("tw-w-28");
        removeButtonDiv.appendChild(removeButton);

        div.appendChild(customerIdDiv);
        div.appendChild(jobCountDiv);
        div.appendChild(removeButtonDiv);

        return div;
    }

    async save() {
        this.hideMessages();
        this.saveButtonTarget.disabled = true;

        const customerMappings = {};
        this.customerMappingsContainerTarget.querySelectorAll("[data-customer-id]").forEach((row) => {
            const customerId = row.querySelector('input[type="text"]').value;
            const jobCountInput = row.querySelector('input[type="number"]');
            const jobCount = jobCountInput.value ? parseInt(jobCountInput.value, 10) : 0;
            if (customerId) {
                customerMappings[customerId] = jobCount;
            }
        });

        const payload = {
            otherCampaignPoolSize: parseInt(this.otherCampaignPoolSizeInputTarget.value, 10),
            customerInternalIdsToNumberOfRecurrentJobIds: customerMappings,
            prioListRecurrentJobIds: [],
            flexMembershipRecurrentJobIds: [],
        };

        const response = await fetch("/_/admin/indeed-campaign-management/sync-config/editor", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            this.successMessageTarget.classList.remove("tw-hidden");
        } else {
            const errorData = await response.json();
            this.errorMessageBodyTarget.textContent = errorData.message;
            this.errorMessageTarget.classList.remove("tw-hidden");
        }

        this.saveButtonTarget.disabled = false;
    }
}
